import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../auth_services/useAuth';
// material
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// icons-material
import RoofingIcon from '@mui/icons-material/Roofing';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SellIcon from '@mui/icons-material/Sell';
import CampaignIcon from '@mui/icons-material/Campaign';
import StorefrontIcon from '@mui/icons-material/Storefront';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StoreIcon from '@mui/icons-material/Store';

import thana_logo from "../../../picture/logo/thana_logo.png";

const ListItemStyle = (menuStatus) => {
    return ({
        color: 'text.leftmenu',
        borderRadius: '8px',
        marginBottom: '5px',
        color: (menuStatus) ? 'text.fixed' : '',
    })
};

const ListItemIconStyle = (size, menuStatus) => {
    return ({
        color: (menuStatus) ? 'text.fixed' : '',
        '&.MuiListItemIcon-root': {
            minWidth: (size == 'small') ? '30px' : '35px'
        },
    })
};

const ListItemIconStyleForSubList = (size, menuStatus) => {
    return ({
        '&.MuiListItemIcon-root': {
            minWidth: (size == 'small') ? '30px' : '55px'
        },
        color: (menuStatus) ? 'text.fixed' : ''
    })
};

const subMenuStyle = {
    //marginLeft: '30px',
    paddingLeft: '60px',
    borderRadius: '10px',
    marginBottom: '5px'
}

const IconSize = (menuStatus) => {
    return ({
        fontSize: '22px',
    })
};


const miniSubMenuIcon = {
    ml: 0.8,
    mt: 1
}

const menuIconAndText = {
    ml: '-20px'
}

const iconAndText = {
    ml: '0px'
}

const Leftmenu = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuActive, setMenuActive] = useState('');
    const [open, setOpen] = useState({
        report: false,
        product: false,
        user: false,
        setting: false,
        terminal: false,
        elephant: false,
        merchant: false
    });

    useEffect(() => {
        if (props.menuActive != undefined) {
            //console.log('True');
            setMenuActive(props.menuActive);

            if (
                props.menuActive == '/dashboard' ||
                props.menuActive == '/sale' ||
                props.menuActive == '/bill' ||
                props.menuActive == '/customer' ||
                props.menuActive == '/settings/merchant_info' ||
                props.menuActive == '/package/view'
            ) {
                setOpen({
                    report: false,
                    product: false,
                    user: false,
                    setting: false,
                    terminal: false,
                    elephant: false,
                    merchant: false
                })
            } else {
                setOpen({
                    report: props.mainMenuActive?.includes('report') ? true : false,
                    product: props.mainMenuActive?.includes('product') ? true : false,
                    user: props.mainMenuActive?.includes('user') ? true : false,
                    setting: props.mainMenuActive?.includes('setting') ? true : false,
                    terminal: props.mainMenuActive?.includes('terminal') ? true : false,
                    elephant: props.mainMenuActive?.includes('elephant') ? true : false,
                    merchant: props.mainMenuActive?.includes('merchant') ? true : false,
                })
            }
        }

    }, [props.menuActive, props.drawerStatus]);

    /*** Handle sale customer screen*/
    useEffect(() => {
        window.addEventListener("storage", onStorageUpdate);
        return () => {
            window.removeEventListener("storage", onStorageUpdate);
        };
    }, []);

    const [smallLeftMenu, setSmallLeftMenu] = useState(false);
    const onStorageUpdate = (e) => {
        const { key, newValue } = e;
        // Order item
        if (key === "mm") {
            setSmallLeftMenu(newValue);
        }
    };

    // Dashboard
    const dashboard = [
        {
            'permission': true,
            'link_name': 'Dashboard',
            'path': '/dashboard',
            'icon': <RoofingIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'permission': true,
            'link_name': 'ລາຍການນໍາໃຊ້',
            'path': '/transaction',
            'icon': <AssessmentIcon sx={IconSize(props.menuStatus)} />
        }
    ];

    // Merchant
    const Merchant = [
        {
            'role': 'all',
            'link_name': 'Payment provider',
            'lng': 'merchant payment info',
            'path': '/merchant_paymentinfo',
            'icon': <StorefrontIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'role': 'all',
            'link_name': 'ຂໍ້ມູນຮ້ານຄ້າ',
            'lng': 'merchant',
            'path': '/merchant',
            'icon': <StoreIcon sx={IconSize(props.menuStatus)} />
        },
    ];

    // User group menu
    const User = [
        {
            'role': 'all',
            'link_name': 'ຂໍ້ມູນສ່ວນຕົວ',
            'lng': 'profile',
            'path': '/profile',
            'icon': <AccountCircleIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'role': useAuth.role(),
            'link_name': 'ຂໍ້ມູນຜູ້ໃຊ້ລະບົບ',
            'lng': 'user',
            'path': '/user',
            'icon': <PeopleAltIcon sx={IconSize(props.menuStatus)} />
        },
    ];

    const [anchorEl, setAnchorEl] = useState(null);
    const openMiniMenu = Boolean(anchorEl);
    const [miniMenu, setMiniMenu] = useState([]);
    const handleClick = (event, menuVal) => {

        if (menuVal == 'report') {
            //setMiniMenu(report);
        } else if (menuVal == 'product') {
            //setMiniMenu(product);
        } else if (menuVal == 'user') {
            setMiniMenu(User);
        } else if (menuVal == 'merchant') {
            setMiniMenu(Merchant);
        }

        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const Menumini = (
        <>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMiniMenu}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: -0.1,
                            ml: 0.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 26,
                                left: -5,
                                right: 0,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                {
                    miniMenu.map((text, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                navigate(text.path);
                                handleClose();
                            }}
                        >
                            <ListItemIcon>
                                {text.icon}
                            </ListItemIcon>
                            {text.link_name}
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    );

    return (
        <>
            {Menumini}
            <Box position="fixed" sx={{ zIndex: 1 }}>
                <Box
                    sx={{
                        marginLeft: '0px',
                        marginTop: '0px',
                        backgroundColor: 'background.leftmenu',
                        padding: '15px 0px 0px 5px',
                        color: 'text.fixed',

                    }}
                >
                    <Box sx={{ color: 'text.fixed', paddingLeft: '15px' }}>
                        <img style={{ width: '100px' }} alt="" src={thana_logo} />
                    </Box>
                </Box>
            </Box>
            <Box sx={{ marginTop: '70px', zIndex: 0 }}>
                {/*** Dashboard */}
                {
                    dashboard.map((text, index) => (
                        text.permission &&
                        <ListItemButton
                            sx={ListItemStyle((location.pathname === text.path || menuActive === text.path) ? true : false)}
                            key={text.link_name}
                            component={NavLink}
                            to={text.path}
                            target={(text.path == '/sale/customer/screen') ? '_blank' : ''}
                            selected={location.pathname === text.path || menuActive === text.path}
                            onClick={props.setOnMenuClose}
                        >
                            <ListItemIcon sx={ListItemIconStyle(props.menuStatus, (location.pathname === text.path || menuActive === text.path) ? true : false)}>
                                <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                    {text.icon}
                                </Tooltip>
                            </ListItemIcon>
                            <ListItemText sx={iconAndText}>
                                {(() => {
                                    if (props.menuStatus != 'small') {
                                        return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                    } else {
                                        return (<>&nbsp;</>)
                                    }
                                })()}
                            </ListItemText>
                        </ListItemButton>
                    ))
                }

                {/*** Merchant */}
                <>
                    <ListItemButton
                        sx={ListItemStyle((props.menuStatus == 'small' && props.mainMenuActive === 'merchant') ? true : false)}
                        selected={props.menuStatus == 'small' && props.mainMenuActive === 'merchant'}
                        onClick={(e) => {
                            setOpen({ merchant: !open.merchant });
                            if (props.menuStatus == 'small') {
                                handleClick(e, 'merchant');
                            }
                        }}
                    >
                        <ListItemIcon sx={ListItemIconStyleForSubList(props.menuStatus, (props.menuStatus == 'small' && props.mainMenuActive === 'merchant') ? true : false)}>
                            <StoreIcon sx={IconSize(props.menuStatus)} />
                        </ListItemIcon>
                        <ListItemText primary={props.menuStatus != 'small' ? "ຂໍ້ມູນຮ້ານຄ້າ" : ""} sx={menuIconAndText} />
                        {props.menuStatus != 'small' ? open.merchant ? <ExpandLess /> : <ExpandMore /> : ''}
                        {props.menuStatus == 'small' ? <ArrowDropDownIcon sx={miniSubMenuIcon} /> : ''}
                    </ListItemButton>
                    {props.menuStatus != 'small' &&
                        <Collapse in={open.merchant} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {
                                    Merchant.map((text, index) => (
                                        <ListItemButton
                                            sx={subMenuStyle}
                                            key={text.link_name}
                                            component={NavLink}
                                            to={text.path}
                                            onClick={props.setOnMenuClose}
                                            selected={location.pathname === text.path || menuActive === text.path}
                                        >
                                            <ListItemText>
                                                {(() => {
                                                    if (props.menuStatus != 'small') {
                                                        return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                                    } else {
                                                        return (<>&nbsp;</>)
                                                    }
                                                })()}
                                            </ListItemText>
                                        </ListItemButton>
                                    ))
                                }
                            </List >
                        </Collapse>
                    }
                </>

                {/*** User*/}
                <>
                    <ListItemButton
                        sx={ListItemStyle((props.menuStatus == 'small' && props.mainMenuActive === 'user') ? true : false)}
                        selected={props.menuStatus == 'small' && props.mainMenuActive === 'user'}
                        onClick={(e) => {
                            setOpen({ user: !open.user });
                            if (props.menuStatus == 'small') {
                                handleClick(e, 'user');
                            }
                        }}
                    >
                        <ListItemIcon sx={ListItemIconStyleForSubList(props.menuStatus, (props.menuStatus == 'small' && props.mainMenuActive === 'user') ? true : false)}>
                            <AccountCircleIcon sx={IconSize(props.menuStatus)} />
                        </ListItemIcon>
                        <ListItemText primary={props.menuStatus != 'small' ? "ຂໍ້ມູນຜູ້ໃຊ້ລະບົບ" : ""} sx={menuIconAndText} />
                        {props.menuStatus != 'small' ? open.user ? <ExpandLess /> : <ExpandMore /> : ''}
                        {props.menuStatus == 'small' ? <ArrowDropDownIcon sx={miniSubMenuIcon} /> : ''}
                    </ListItemButton>
                    {props.menuStatus != 'small' &&
                        <Collapse in={open.user} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {
                                    User.map((text, index) => (
                                        <ListItemButton
                                            sx={subMenuStyle}
                                            key={text.link_name}
                                            component={NavLink}
                                            to={text.path}
                                            onClick={props.setOnMenuClose}
                                            selected={location.pathname === text.path || menuActive === text.path}
                                        >
                                            <ListItemText>
                                                {(() => {
                                                    if (props.menuStatus != 'small') {
                                                        return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                                    } else {
                                                        return (<>&nbsp;</>)
                                                    }
                                                })()}
                                            </ListItemText>
                                        </ListItemButton>
                                    ))
                                }
                            </List >
                        </Collapse>
                    }
                </>

            </Box >
        </>
    )

}

export default Leftmenu